module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', [_c('a', {
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Document Requirements")]), _c('h2', [_vm._v("Requirement " + _vm._s(_vm.entity_type) + " " + _vm._s(_vm.entity_id))]), _c('DocumentRequirementForm', {
    model: {
      value: (_vm.body),
      callback: function($$v) {
        _vm.body = $$v
      },
      expression: "body"
    }
  }), _c('div', {
    staticClass: "row columns text-center"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.save
    }
  }, [_vm._v("Add requirement")])], 1), _c('hr'), _c('h2', [_vm._v("Document Requirements")]), (_vm.loading) ? _c('loading-spinner') : _vm._e(), (!_vm.loading && _vm.requirements.length === 0) ? [_c('h2', [_vm._v("Vehicle category has no requirements")])] : _vm._e(), _vm._l((_vm.requirements), function(item) {
    return (_vm.requirements.length) ? _c('document-requirement', {
      attrs: {
        "item": item,
        "type": "listing"
      },
      on: {
        "itemUpdated": _vm.loadRequirements
      }
    }) : _vm._e()
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-650a75f4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/RequirementModal.vue
// module id = 2545
// module chunks = 1